module.exports = __webpack_public_path__ + "static/hero-4269f8a4990a650c527c996d4e0f8811.png";